import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withHashLocation } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { APP_BASE_HREF } from "@angular/common";
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimations(),
    { provide: APP_BASE_HREF, useValue: "/" },
    { provide: ICON_SETTINGS, useValue: { type: "font" } },
  ],
};
